import { API } from './resources'

export default {
  create: (data) => {
    return API.post('/award', data)
  },
  get: (siteSource, limit, offset) => {
    return API.get('/award', { params: { siteSource, limit, offset } })
  },
  update: (awardID, data) => {
    return API.put(`/award/${awardID}`, data)
  },
  giveUserPermission: (userID, awardID) => {
    return API.post(`award/${awardID}/user/${userID}`)
  },
  removeUserPermission: (userID, awardID) => {
    return API.delete(`award/${awardID}/user/${userID}`)
  },
  giveProjectAward: (projectID, awardID) => {
    return API.post(`award/${awardID}/project/${projectID}`)
  },
  delete: (awardID) => {
    return API.delete(`/award/${awardID}`)
  }
}
